import { articleListApi } from '@/entities/article';
import { PATH } from '@/shared/constants';
import { LandingArticleItemProps } from '@/shared/types';
import { loggingError } from '@/shared/utils';

export const getRecentContents = async () => {
  try {
    const response = await articleListApi({
      ordering: 'landing_new',
    });

    const recentContents: LandingArticleItemProps[] = response.data.results.map(
      (article) => ({
        articleInfo: {
          id: article.id,
          category: article.category[0].name,
          categoryFlag: article.category[0].flag,
          time: article.read_time,
          title: article.title,
          isPopular: article.is_popular_news,
          isScrapped: article.is_news_scrapped,
          imageUrl: article.thumbnail_image,
        },
        authorInfo: {
          name: article.author.name,
          href: `${PATH.HOME}/@${article.author.author_url_identifier}`,
          imgUrl: article.author.image_url,
        },
      })
    );

    return recentContents;
  } catch (error) {
    loggingError(error, {
      message: 'Failed to fetch RecentContents data',
      path: '/',
      extra: {},
    });

    return [];
  }
};
